module.exports = __webpack_public_path__ + "img/SYS.970b8719.svg";